import React from 'react'
import ContentWrapper from '../components/ContentWrapper'

export default function Template({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const { markdownRemark } = data // data.markdownRemark holds our post data
  const { frontmatter, html } = markdownRemark

  return (
    <section>
      <ContentWrapper meta={frontmatter} content={html}/>
      {/* <section className="markdown-content" style={{maxWidth:'100%'}}> */}
      {/* <section className="container marg-b-3 relative row marg-t-2 marg-b-2 content-wrapper" style={{maxWidth:'100%'}}>
        <h2>{frontmatter.type}</h2>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </section> */}
    </section>
  )
}

export const query = graphql`
  query BlogPostQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      excerpt
      frontmatter {
        title
        type
        documentTitle
        authors
        date
        docType
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/docs-markdown.js